import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import "./LogList.css";

const LogList = ({ hrmEventsList, currentPage, perPage, loading }) => {

    const normalizeTimestampMs = (ts) => {
        if (ts === null || ts === undefined) return null;
        const n = Number(ts);
        if (!Number.isFinite(n)) return null;
        return n < 1_000_000_000_000 ? n * 1000 : n;
    };

    const srNumberFormatter = (cell, row, rowIndex, formatExtraData) => {
        if (currentPage > 1)
            return <>{perPage * (currentPage - 1) + (rowIndex + 1)}</>;
        else return <>{rowIndex + 1}</>;
    };

    const dateFormatter = (cell, row) => {
        const tsMs = normalizeTimestampMs(row?.eventTimestamp);
        if (!tsMs) return "-";
        const m = moment(tsMs);
        if (!m.isValid()) return "-";
        return `${m.format("MM/DD/YYYY")} ${m.format("hh:mm A")}`;
    };

    const descriptionFormatter = (cell, row) => {
        const typeName = row?.eventTypeName;
        const desc = row?.eventDescription;
        if (typeName && desc) return `${typeName} - ${desc}`;
        return typeName || desc || "-";
    };

    const columns = [
        {
            dataField: "id",
            text: "No.",
            formatter: srNumberFormatter,
            headerStyle: () => ({ width: "72px" }),
        },
        {
            dataField: "eventTimestamp",
            text: "EVENT DATE/TIME",
            formatter: dateFormatter,
            headerStyle: () => ({ width: "60%" }),
        },
        {
            dataField: "eventDescription",
            text: "EVENT DESCRIPTION",
            formatter: descriptionFormatter,
        },
    ];

    const defaultSorted = [
        {
            dataField: "reportedAt",
            order: "desc",
        },
    ];

    const rows = (
        Array.isArray(hrmEventsList)
            ? hrmEventsList
            : hrmEventsList?.monitoringEventLogs || []
    )
        .slice()
        .sort((t1, t2) => {
            const a = normalizeTimestampMs(t1?.eventTimestamp) ?? 0;
            const b = normalizeTimestampMs(t2?.eventTimestamp) ?? 0;
            return b - a;
        });

    if (!loading && rows.length === 0) {
        return (
            <div className="log-list-empty">
                No monitoring events found for the selected date range.
            </div>
        );
    }

    return (
        <div>
            <BootstrapTable
                keyField="id"
                wrapperClasses="log-list-table-wrapper"
                classes="log-list-table"
                headerClasses="log-list-table-header"
                data={rows}
                columns={columns}
                striped
                hover
                condensed
                bordered={false}
                defaultSorted={defaultSorted}
            />
        </div>
    );
};

export default LogList;
